import forEach from 'lodash/forEach'
import isObject from 'lodash/isObject'
import camelCase from 'lodash/camelCase'
/**
 * Utility to transform SNAKE_CASE into camelCase.
 *
 * @param  {Mixed}   data
 * @param  {Boolean} toCamelCase
 * @return {Mixed}
 */
function transformJson(data, toCamelCase = false) {
  // do not loop through the data if it's not an object
  if ( ! isObject(data)) return data

  if (Array.isArray(data)) {
    // loop through array of data
    return data.map((item) => transformJson(item, toCamelCase))

  } else {
    // loop through object keys
    let json = {}

    forEach(data, (val, key) => {
      let newKey = toCamelCase ? camelCase(key) : makeSnakeCase(key)
      json[newKey] = transformJson(val, toCamelCase)
    })

    return json

  }
}

export default transformJson

/**
 * Transform from SNAKE_CASE to camelCase.
 *
 * @param  {String} key
 * @return {String}
 */
function makeCamelCase(key) {
  key = key.toLowerCase()
  if (!key.includes('_')) {
    return key
  }
  return key.split('_')
    .map((word, i) => {
      // do not capitalize the first word of the key
      if (i === 0) return word
      // only capitalize the words afterwards
      return word.charAt(0).toUpperCase() + word.slice(1)
    })
    .join('')
}

/**
 * Transform from camelCase to SNAKE_CASE.
 *
 * @param  {String} key
 * @return {String}
 */
function makeSnakeCase(key) {
  return key.split(/(?=[A-Z])/).map((word) => word.toUpperCase()).join('_')
}

/**
 * transform object key to lowercase first
 * 
 * @param {object} obj 
 */
export function toLowerFirst(data) {
  // do not loop through the data if it's not an object
  if ( ! isObject(data)) return data

  if (Array.isArray(data)) {
    // loop through array of data
    return data.map((item) => toLowerFirst(item))

  } else {
    // loop through object keys
    let json = {}

    forEach(data, (val, key) => {
      let newKey = key.charAt(0).toLowerCase() + key.slice(1)
      json[newKey] = toLowerFirst(val)
    })

    return json

  }
}
/**
 * transform object key to Uppercase first
 * 
 * @param {object} obj 
 */
export function toUpperFirst(data) {
  // do not loop through the data if it's not an object
  if ( ! isObject(data)) return data

  if (Array.isArray(data)) {
    // loop through array of data
    return data.map((item) => toUpperFirst(item))

  } else {
    // loop through object keys
    let json = {}

    forEach(data, (val, key) => {
      let newKey = key.charAt(0).toUpperCase() + key.slice(1)
      json[newKey] = toUpperFirst(val)
    })

    return json

  }
}